import { Autocomplete, TextField } from '@mui/material';
import FieldRow from 'components/FormElements/FieldRow';
import { useFirm } from 'hooks/data/firm/useFirm';

interface Props {
  title: string;
  associatedFirmIds: Array<string>;
  onChange: (firmIds: Array<string>) => void;
}

const AssociatedFirms: React.FC<Props> = ({
  title,
  associatedFirmIds,
  onChange,
}) => {
  const firmsResponse = useFirm({ params: {} });
  const firms = (firmsResponse.firms?.data?.result ?? []).filter(
    (firm) => !firm.isLpFirm,
  );

  const selectedFirms = firms.filter((firm) =>
    associatedFirmIds.includes(firm._id),
  );

  return (
    <FieldRow title={title} centerTitle>
      <Autocomplete
        multiple
        options={firms}
        getOptionLabel={(option) => option.firmName}
        getOptionKey={(option) => option._id}
        filterSelectedOptions
        value={selectedFirms}
        onChange={(_, newValue) => onChange(newValue.map((firm) => firm._id))}
        renderInput={(params) => (
          <TextField {...params} size="small" variant="outlined" fullWidth />
        )}
      />
    </FieldRow>
  );
};

export default AssociatedFirms;
